import React, { createContext, useState, useEffect, useContext } from "react";
import publicApi from "../../publicApi";

const ServerStatusContext = createContext();

export const useServerStatus = () => useContext(ServerStatusContext);

export const ServerStatusProvider = ({ children }) => {
  const [isServerOnline, setIsServerOnline] = useState(true);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkServerStatus = async () => {
      try {
        await publicApi.get("/products");
        setIsServerOnline(true);
      } catch (error) {
        if (error.code === "ERR_NETWORK") {
          setIsServerOnline(false);
        }
      } finally {
        setIsLoading(false);
      }
    };

    checkServerStatus();

    const intervalId = setInterval(checkServerStatus, 30000);

    return () => clearInterval(intervalId);
  }, []);

  const value = { isServerOnline, isLoading };

  return (
    <ServerStatusContext.Provider value={value}>
      {children}
    </ServerStatusContext.Provider>
  );
};
